<template>
  <div class="page-content">
    <section class="input-action">
      <div class="input">
        <input
          v-model="filter.text"
          :placeholder="'ค้นหาชื่อจังหวัด'"
          type="text"
          class="el-input__inner"
          @keyup.enter="() => search(filter.text, 1)"
        />
      </div>
      <div class="action">
        <el-button
          icon="
            el-icon-search
          "
          @click="() => search(filter.text, 1)"
        >
          ค้นหา
        </el-button>
      </div>
    </section>

    <section v-if="loader" class="empty">
      <p>
        <b class="unknown"> กำลังค้นหา </b>
      </p>
    </section>

    <section v-if="!loader && items.length > 0" class="content">
      <div v-for="(item, i) in items" :key="i" class="item">
        <p class="item-content">
          {{ item.name }}
        </p>
        <el-button
          type="sc-asset"
          class="item-action"
          @click="() => (value = item)"
        >
          เลือก
        </el-button>
      </div>
    </section>

    <section v-else-if="!loader" class="empty">
      <img src="@/assets/images/admin/empty.png" />
      <p>
        <b class="unknown"> ไม่พบข้อมูล </b>
      </p>
    </section>

    <section v-if="items.length > 0" class="footer">
      <el-pagination
        :background="true"
        :layout="'prev, pager, next'"
        :pager-count="5"
        :current-page="paging.page"
        :page-size="paging.limit"
        :total="paging.total"
        @current-change="(page) => search(filter.text, page)"
      />
    </section>
  </div>
</template>

<script>
// Services
import { NonScFeature } from "../feature"

export default {
  props: {
    selected: {
      type: String,
      default: undefined,
    },
    reset: Boolean,
  },
  data: () => ({
    value: null,
    items: [],
    filter: {
      text: "",
    },
    source: {
      items: [],
      total: 0,
    },
    paging: {
      page: 1,
      limit: 12,
      total: 0,
    },
    loader: false,
  }),
  computed: {
    address() {
      return NonScFeature.address
    },
    state() {
      return this.address.state.province
    },
  },
  watch: {
    "source.total": function sourceTotalWatcher() {
      this.search(this.filter.text, this.paging.page)
    },
    value(value) {
      this.$emit("selected", value)
    },
    loader(value) {
      this.$emit("loading", value)
    },
  },
  mounted() {
    // Province State
    const { items, total } = this.state

    // Validate State
    if (total > 0) {
      this.source = { items, total }
    } else {
      this.get()
    }
  },
  methods: {
    search(text = "", page = 1) {
      // Loading
      this.loader = true

      // Province Datasource
      const { items } = this.source

      // Validate Items
      if (items.length < 0) return

      // Province Name Filter
      const tester = ({ name }) => new RegExp(text, "gm").test(name)

      // Filter Province
      const result = items.filter(tester)

      // Paging Props
      const { limit } = this.paging

      // Paging Limitation
      const start = page * limit - limit
      const end = start + limit

      // Province Filter
      this.filter = { text }

      // Province List
      this.items = result.slice(start, end)

      // Province Paging
      this.paging = {
        limit,
        page,
        total: result.length,
      }

      // Close Loader
      setTimeout(() => {
        this.loader = false
      }, 400)
    },
    async get() {
      // Loading
      this.loader = true

      try {
        // Fetch Province List
        this.source = await this.address.province()

        // Validate Result
        if (this.source.total > 0) {
          this.search()
        }
      } catch (_) {
        // Reset Items
        this.items = []

        // Reset Paging
        Object.assign(this.paging, { page: 1, total: 0 })
      } finally {
        setTimeout(() => {
          this.loader = false
        }, 400)
      }
    },
  },
}
</script>

<style lang="css" scoped>
.page-content {
  gap: var(--size-md);
}

section {
  gap: var(--size-sm);
  flex-direction: column;
}
section.input-action {
  flex-direction: row;
}
section.content {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  overflow: auto;
}
section.footer {
  align-items: center;
}

.item {
  align-items: center;
  justify-content: space-between;
  padding: var(--size-xs) 0.75rem;
}

@media screen and (max-width: 768px) {
  section .content {
    grid-template-columns: 1fr;
  }
}
</style>
